import { Col, Divider, Modal, notification, Row, Table } from "antd";
import React, { useCallback, useEffect, useMemo } from "react";
import {
  getColumnDateSearchProps,
  getColumnNumberSearchProps,
  getColumnSearchProps,
} from "../../../../../../../../utils/tableUtils";
import moment from "moment";
import { useSelector } from "react-redux";
import { numberMask } from "../../../../../../../../services/helpersMethodsService";
import { useState } from "react";
import useWindowSize from "../../../../../../../../hooks/useWindowSize";
import { ContainerSelectFinancialInstallmentsModal } from "./styles";
import ButtonStandard from "../../../../../../../../components/utils/button";
import { useConciliationContext } from "../../../../../../../../hooks/useConciliationContext";
import { getParameterItems } from "../../../../../../../../services/generalParameterService";

// import { Container } from './styles';

const TYPES = ["income", "expense"];
const CODES_PARAMETERS = [4004];

function SelectFinancialInstallmentsModal() {
  const [parametersValue, setParametersValue] = useState([]);
  const [selectedRowsKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const { width } = useWindowSize();
  const {
    dataListFinancialInstallments: dataList,
    isLoadingDataListFinancialInstallments: isLoadingDataList,
    tablePropertiesFinancialInstallments: {
      size,
      page,
      tableFilters,
      tableSorters,
    },
    handleTableChangeFinancialInstallments,
    isModalSelectFinancialInstallmentsVisible: visible,
    closeModalSelectFinancialInstallments,
    selectedConciliationTransaction,
    updateStatementTransactions,
  } = useConciliationContext();

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const isEnablePaymentMethod = useMemo(() => {
    return (
      parametersValue.find((parameter) => parameter.code === 4004) &&
      parametersValue.find((parameter) => parameter.code === 4004).value ===
        "true"
    );
  }, [parametersValue]);

  const totalSelectRowsValuesNumber = useMemo(() => {
    return selectedRows.reduce((acc, row) => {
      const valueTransaction =
        row.transactionType === "income" ? 1 * row.value : -1 * row.value;
      return acc + (valueTransaction || 0);
    }, 0);
  }, [selectedRows]);

  const totalValuesSelectedString = useMemo(() => {
    return selectedRows.length > 0
      ? numberMask(totalSelectRowsValuesNumber, true)
      : 0;
  }, [selectedRows, totalSelectRowsValuesNumber]);

  const handleSearch = useCallback((selectedKeys, confirm) => {
    confirm();
  }, []);

  const handleReset = useCallback((clearFilters) => {
    clearFilters();
  }, []);

  const handleCancel = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    closeModalSelectFinancialInstallments();
  };

  const handleConfirm = () => {
    const selectedSum = totalSelectRowsValuesNumber;
    const statementAmount =
      selectedConciliationTransaction?.statementTransactionAmount || 0;
    if (
      Math.abs(selectedSum.toFixed(2)) !==
      Math.abs(Number(statementAmount.toFixed(2)))
    ) {
      notification.error({
        message:
          translation.conciliation.messages
            .errorWrongSumValuesMessageOnSelectInstallmentModal,
        description:
          translation.conciliation.messages
            .errorWrongSumValuesDescriptionOnSelectInstallmentModal,
      });
      return;
    }
    updateStatementTransactions(selectedRowsKeys, selectedRows);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    closeModalSelectFinancialInstallments();
  };

  const columns = useMemo(() => {
    return isEnablePaymentMethod === true
      ? [
          {
            title: translation.conciliation.table.columns.billingDate,
            dataIndex: "expirationDate",
            key: "expirationDate",
            width: 120,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "expirationDate" &&
              tableSorters?.order,
            filteredValue: tableFilters.expirationDate || null,
            ...getColumnDateSearchProps(
              "expirationDate",
              handleReset,
              handleSearch
            ),
            render: (text) => moment(text).format("DD/MM/YYYY"),
          },
          {
            title: translation.conciliation.table.columns.value,
            dataIndex: "value",
            key: "value",
            width: 150,
            sorter: true,
            align: "right",
            sortOrder:
              tableSorters?.columnKey === "value" && tableSorters?.order,
            filteredValue: tableFilters.value || null,
            ...getColumnNumberSearchProps("value", handleReset, handleSearch),
            render: (text) => numberMask(text, true),
          },
          {
            title: translation.conciliation.table.columns.supplierClientName,
            dataIndex: "supplierClientName",
            key: "supplierClientName",
            width: 200,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "supplierClientName" &&
              tableSorters?.order,
            filteredValue: tableFilters.supplierClientName || null,
            ...getColumnSearchProps(
              "supplierClientName",
              handleReset,
              handleSearch
            ),
          },
          {
            title: translation.conciliation.table.columns.documentNumber,
            dataIndex: "documentNumber",
            key: "documentNumber",
            width: 150,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "documentNumber" &&
              tableSorters?.order,
            filteredValue: tableFilters.documentNumber || null,
            ...getColumnSearchProps(
              "documentNumber",
              handleReset,
              handleSearch
            ),
          },
          {
            title: translation.conciliation.table.columns.paymentMethodName,
            width: 200,
            dataIndex: "paymentMethodName",
            key: "paymentMethodName",
          },
          {
            title: translation.conciliation.table.columns.installmentNumber,
            dataIndex: "installmentNumber",
            key: "installmentNumber",
            width: 120,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "installmentNumber" &&
              tableSorters?.order,
            filteredValue: tableFilters.installmentNumber || null,
            ...getColumnSearchProps(
              "installmentNumber",
              handleReset,
              handleSearch
            ),
            render: (text, record) =>
              record.installmentNumber + "/" + record.installmentTotal,
          },
          {
            title: translation.conciliation.table.columns.transactionType,
            dataIndex: "transactionType",
            key: "transactionType",
            width: 100,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "transactionType" &&
              tableSorters?.order,
            filtered: true,
            filteredValue: tableFilters.transactionType || null,
            filters: TYPES.map((transactionType) => ({
              text: translation.conciliation.transactionTypes[transactionType],
              value: transactionType,
            })),
            render: (text) => translation.conciliation.transactionTypes[text],
          },
          {
            title: translation.conciliation.table.columns.bankAccountFarmName,
            dataIndex: "bankAccountFarmName",
            key: "bankAccountFarmName",
            width: 200,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "bankAccountFarmName" &&
              tableSorters?.order,
            filteredValue: tableFilters.bankAccountFarmName || null,
            ...getColumnSearchProps(
              "bankAccountFarmName",
              handleReset,
              handleSearch
            ),
          },
        ]
      : [
          {
            title: translation.conciliation.table.columns.billingDate,
            dataIndex: "expirationDate",
            key: "expirationDate",
            width: 120,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "expirationDate" &&
              tableSorters?.order,
            filteredValue: tableFilters.expirationDate || null,
            ...getColumnDateSearchProps(
              "expirationDate",
              handleReset,
              handleSearch
            ),
            render: (text) => moment(text).format("DD/MM/YYYY"),
          },
          {
            title: translation.conciliation.table.columns.value,
            dataIndex: "value",
            key: "value",
            sorter: true,
            align: "right",
            sortOrder:
              tableSorters?.columnKey === "value" && tableSorters?.order,
            filteredValue: tableFilters.value || null,
            ...getColumnNumberSearchProps("value", handleReset, handleSearch),
            render: (text) => numberMask(text, true),
          },
          {
            title: translation.conciliation.table.columns.supplierClientName,
            dataIndex: "supplierClientName",
            key: "supplierClientName",
            width: 200,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "supplierClientName" &&
              tableSorters?.order,
            filteredValue: tableFilters.supplierClientName || null,
            ...getColumnSearchProps(
              "supplierClientName",
              handleReset,
              handleSearch
            ),
          },
          {
            title: translation.conciliation.table.columns.documentNumber,
            dataIndex: "documentNumber",
            key: "documentNumber",
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "documentNumber" &&
              tableSorters?.order,
            filteredValue: tableFilters.documentNumber || null,
            ...getColumnSearchProps(
              "documentNumber",
              handleReset,
              handleSearch
            ),
          },
          {
            title: translation.conciliation.table.columns.installmentNumber,
            dataIndex: "installmentNumber",
            key: "installmentNumber",
            width: 120,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "installmentNumber" &&
              tableSorters?.order,
            filteredValue: tableFilters.installmentNumber || null,
            ...getColumnSearchProps(
              "installmentNumber",
              handleReset,
              handleSearch
            ),
            render: (text, record) =>
              record.installmentNumber + "/" + record.installmentTotal,
          },
          {
            title: translation.conciliation.table.columns.transactionType,
            dataIndex: "transactionType",
            key: "transactionType",
            width: 100,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "transactionType" &&
              tableSorters?.order,
            filtered: true,
            filteredValue: tableFilters.transactionType || null,
            filters: TYPES.map((transactionType) => ({
              text: translation.conciliation.transactionTypes[transactionType],
              value: transactionType,
            })),
            render: (text) => translation.conciliation.transactionTypes[text],
          },
          {
            title: translation.conciliation.table.columns.bankAccountFarmName,
            dataIndex: "bankAccountFarmName",
            key: "bankAccountFarmName",
            width: 200,
            sorter: true,
            sortOrder:
              tableSorters?.columnKey === "bankAccountFarmName" &&
              tableSorters?.order,
            filteredValue: tableFilters.bankAccountFarmName || null,
            ...getColumnSearchProps(
              "bankAccountFarmName",
              handleReset,
              handleSearch
            ),
          },
        ];
  }, [
    handleReset,
    handleSearch,
    isEnablePaymentMethod,
    tableFilters.bankAccountFarmName,
    tableFilters.documentNumber,
    tableFilters.expirationDate,
    tableFilters.installmentNumber,
    tableFilters.supplierClientName,
    tableFilters.transactionType,
    tableFilters.value,
    tableSorters,
    translation.conciliation.table.columns.bankAccountFarmName,
    translation.conciliation.table.columns.billingDate,
    translation.conciliation.table.columns.documentNumber,
    translation.conciliation.table.columns.installmentNumber,
    translation.conciliation.table.columns.paymentMethodName,
    translation.conciliation.table.columns.supplierClientName,
    translation.conciliation.table.columns.transactionType,
    translation.conciliation.table.columns.value,
    translation.conciliation.transactionTypes,
  ]);

  useEffect(() => {
    let doFetch = true;
    async function getParameters() {
      let dataResult = [];
      try {
        for (var i = 0; i < CODES_PARAMETERS.length; i++) {
          let code = CODES_PARAMETERS[i];
          let {
            data: { results },
          } = await getParameterItems({ groupId, farmId, code });
          results.isDefault = results.farmId == null && results.groupId == null;
          results.updated = false;
          dataResult.push(results);
        }
        setParametersValue(dataResult);
      } catch (error) {
      } finally {
      }
    }
    if (doFetch) getParameters();

    return () => {
      doFetch = false;
    };
  }, [farmId, groupId]);

  return (
    <Modal
      title="Selecionar Mov. Financeira"
      visible={visible}
      maskClosable={false}
      width={width >= 1440 ? 1000 : 800}
      footer={null}
      onCancel={handleCancel}
    >
      <ContainerSelectFinancialInstallmentsModal>
        <Divider>Extrato</Divider>
        <Row type="flex" gutter={8}>
          <Col span={4}>
            <Row>
              <label>
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .statementTransactionDate
                }
              </label>
            </Row>
            <Row>
              <span>
                {selectedConciliationTransaction?.statementTransactionDate
                  ? moment(
                      selectedConciliationTransaction?.statementTransactionDate
                    ).format("DD/MM/YYYY")
                  : "-"}
              </span>
            </Row>
          </Col>
          <Col span={2}>
            <Row>
              <label>
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .statementTransactionType
                }
              </label>
            </Row>
            <Row>
              <span>
                {selectedConciliationTransaction?.statementTransactionType
                  ? translation.statement.types[
                      selectedConciliationTransaction?.statementTransactionType
                    ]
                  : "-"}
              </span>
            </Row>
          </Col>
          <Col span={14}>
            <Row>
              <label>
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .statementTransactionDescription
                }
              </label>
            </Row>
            <Row>
              <span>
                {selectedConciliationTransaction?.statementTransactionDescription ??
                  "-"}
              </span>
            </Row>
          </Col>
          <Col span={4}>
            <Row>
              <label>
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .statementTransactionAmount
                }
              </label>
            </Row>
            <Row>
              <span>
                {numberMask(
                  selectedConciliationTransaction?.statementTransactionAmount ??
                    0,
                  true
                )}
              </span>
            </Row>
          </Col>
        </Row>
        <Divider>BovExo</Divider>
        <Row type="flex">
          <Col span={24}>
            <Table
              rowKey="financialTransactionMainInstallmentId"
              dataSource={dataList?.content || []}
              loading={isLoadingDataList}
              onChange={handleTableChangeFinancialInstallments}
              pagination={{
                total: dataList != null ? dataList.totalElements : 0,
                size: dataList != null ? size : 0,
                current: dataList != null ? page : 0,
                hideOnSinglePage:
                  dataList !== null && Object.entries(dataList).length !== 0
                    ? dataList.totalElements > 10
                      ? false
                      : true
                    : true,
                showSizeChanger: true,
                pageSizeOptions: [
                  "10",
                  "20",
                  "30",
                  "100",
                  "500",
                  "1000",
                  "2000",
                ],
              }}
              scroll={{
                x: 1200,
              }}
              columns={columns}
              rowSelection={{
                selectedRowKeys: selectedRowsKeys,
                onSelect: (record, selected, selectedRows, nativeEvent) => {
                  try {
                    if (selected) {
                      setSelectedRowKeys((old) => [
                        ...old,
                        record.financialTransactionMainInstallmentId,
                      ]);
                      setSelectedRows((old) => [...old, record]);
                    } else {
                      setSelectedRowKeys((old) =>
                        old.filter(
                          (r) =>
                            r !== record.financialTransactionMainInstallmentId
                        )
                      );
                      setSelectedRows((old) =>
                        old.filter(
                          (r) =>
                            r.financialTransactionMainInstallmentId !==
                            record.financialTransactionMainInstallmentId
                        )
                      );
                    }
                  } catch (error) {
                    console.error(error);
                  }
                },
                onSelectAll: (
                  record,
                  selected,
                  selectedRowsParams,
                  nativeEvent
                ) => {
                  // Get just the financialTransactionMainInstallmentIds
                  const keys = selectedRowsParams.map(
                    (sr) => sr.financialTransactionMainInstallmentId
                  );
                  // Get all the selectedAnimalsKeys unless the unselected
                  const lastSelectedAnimalsKeys = selectedRowsKeys.filter(
                    (sAK) => !keys.includes(sAK)
                  );
                  const lastSelectedRows = selectedRows.filter(
                    (sAK) =>
                      !keys.includes(sAK.financialTransactionMainInstallmentId)
                  );
                  if (record) {
                    setSelectedRowKeys((old) => [...old, ...keys]);
                    setSelectedRows((old) => [...old, ...selectedRowsParams]);
                  } else {
                    setSelectedRowKeys(lastSelectedAnimalsKeys);
                    setSelectedRows(lastSelectedRows);
                  }
                },
              }}
            />
          </Col>
        </Row>
        <Row type="flex">
          <Col span={24}>
            <span>
              <label htmlFor="">
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .selectedRows
                }
                {": "}
              </label>

              {selectedRows.length > 0 ? ` (${selectedRows.length})` : " (0)"}
            </span>
          </Col>
        </Row>
        <Row type="flex">
          <Col span={24}>
            <span>
              <label htmlFor="">
                {
                  translation.conciliation.selectFinancialInstallmentsModal
                    .selectedRowsSum
                }
                :
              </label>
              {`${totalValuesSelectedString}`}
            </span>
          </Col>
        </Row>
        <Row type="flex">
          <Col span={24}>
            <span>
              <label htmlFor="">
                {translation.conciliation.selectFinancialInstallmentsModal
                  .differenceLabel || "Diferença"}
                {": "}
              </label>
              {numberMask(
                (Math.abs(
                  selectedConciliationTransaction?.statementTransactionAmount
                ) || 0) - Math.abs(totalSelectRowsValuesNumber.toFixed(2)),
                true
              )}
            </span>
          </Col>
        </Row>
        <Row type="flex" justify="end" gutter={8} style={{ marginTop: 24 }}>
          <Col>
            <ButtonStandard buttonType={"type7"} onClick={handleCancel}>
              {translation.buttons.cancel}
            </ButtonStandard>
          </Col>
          <Col>
            <ButtonStandard buttonType={"type6"} onClick={handleConfirm}>
              {translation.buttons.confirm}
            </ButtonStandard>
          </Col>
        </Row>
      </ContainerSelectFinancialInstallmentsModal>
    </Modal>
  );
}

export default SelectFinancialInstallmentsModal;
